import { tsValidateArray, tsValidateBoolean, tsValidateResult, tsValidateString } from '@nu-art/ts-common';
export const Validator_NoteTemplateSection = (noteSection) => {
    if (!noteSection)
        return 'Did not receive note template section';
    if (noteSection.content?.includes('{}'))
        return { content: 'Found param declaration without a param key: {}' };
    return tsValidateResult(noteSection, {
        title: tsValidateString(undefined, false),
        content: tsValidateString(undefined, false),
        subSections: tsValidateArray(Validator_NoteTemplateSection),
        isSelectable: tsValidateBoolean(),
        isIndented: tsValidateBoolean(),
        isEditable: tsValidateBoolean(),
        defaultSelected: tsValidateBoolean(),
        dispositionSection: tsValidateBoolean(),
    });
};
//# sourceMappingURL=validator.js.map